module.exports = __webpack_public_path__ + "img/graph.f5e71235.svg";